module.exports = __webpack_public_path__ + "res/28-img_media_bg.0528c641f501dd3e77dcfeba7a7d489e.png";